<template>
  <div class="py-2">
    <h4 class="text-secondary">{{ abbonamento.nome }}</h4>
    <div class="col-12">
      <b-form @submit.prevent="onSubmit">
        <b-form-group class="text-left">
          <p class="mb-0 mt-1 text-primary">Nome:</p>
          <b-form-input v-model="abbonamento.nome" name="nome" type="text" required></b-form-input>
          <p class="mb-0 mt-1 text-primary">Slug:</p>
          <b-form-input v-model="abbonamento.slug" name="slug" type="text" required></b-form-input>
          <p class="mb-0 mt-1 text-primary">Descrizione:</p>
          <b-form-input v-model="abbonamento.descrizione" name="descrizione" type="text" required></b-form-input>
          <p class="mb-0 mt-1 text-primary">Durata:</p>
          <b-form-input v-model="abbonamento.durata" name="durata" type="number" required></b-form-input>
          <p class="mb-0 mt-1 text-primary">Prezzo:</p>
          <b-form-input v-model="abbonamento.prezzo" name="prezzo" type="number" required></b-form-input>
          <p class="mb-0 mt-1 text-primary">Id prodotto:</p>
          <b-form-input
            v-model="abbonamento.wc_product_id"
            name="wc_product_id"
            type="number"
            required
          ></b-form-input>
          <p class="mb-0 mt-1 text-primary">Servizi:</p>
          <b-form-checkbox-group id="servizi" v-model="ids" name="servizi" v-if="this.servizi">
            <b-form-checkbox
              v-for="(servizio, ind) in this.servizi"
              :key="ind"
              :value="servizio.id"
            >{{ servizio.slug }}</b-form-checkbox>
          </b-form-checkbox-group>
          <p class="mb-0 mt-1 text-primary">Status:</p>
          <b-form-radio v-model="abbonamento.attivo" name="status" :value="1">attivo</b-form-radio>
          <b-form-radio v-model="abbonamento.attivo" name="status" :value="0">non attivo</b-form-radio>
        </b-form-group>
        <div class="d-flex justify-content-center pb-2 mb-3">
          <b-button class="col-5 mx-auto" variant="primary" type="submit">Salva</b-button>
        </div>
      </b-form>
      <b-button
        variant="secondary"
        type="button"
        block
        @click="deleteAbbonamento"
      >Elimina Abbonamento</b-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "dettaglio-abbonamento",
  props: ["item", "servizi"],
  data() {
    return {
      abbonamento: null,
      ids: [],
      messagge: null
    };
  },
  methods: {
    onSubmit() {
      var url =
        process.env.VUE_APP_VERSION +
        "admin/abbonamenti/" +
        this.abbonamento.hashid;
      this.abbonamento.attivo = this.abbonamento.attivo == 1 ? true : false;
      this.abbonamento.servizi = this.ids;

      this.$axios
        .put(url, this.abbonamento)
        .then(res => {
          this.$router.go();
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    deleteAbbonamento() {
      var url =
        process.env.VUE_APP_VERSION +
        "admin/abbonamenti/" +
        this.abbonamento.hashid;
      this.$axios
        .delete(url)
        .then(res => {
          this.$router.go();
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.abbonamento = this.item;
  },
  mounted() {
    this.item.servizi.forEach(element => {
      this.ids.push(element.id);
    });
  }
};
</script>